<template>
    <div @keydown.esc="close()" class="metronic-index">
        <block :title="blockTitle">
            <ul class="m-portlet__nav" slot="header">
                <li>
                    <ul class="translations-pills nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm" role="tablist" v-if="hasTranslations" style="margin-top: 20px;margin-right: 22px;">
                        <li v-for="lang in $lang.all" class="nav-item m-tabs__item">
                            <a @click.prevent="$lang.current = lang" :class="{'active': $lang.isCurrent(lang)}" class="nav-link m-tabs__link"> {{lang}} </a>
                        </li>
                    </ul>
                </li>
                <li class="m-portlet__nav-item" v-if="showCreateButton">
                    <a class="btn btn-accent m-btn index-new-record m-btn--custom m-btn--icon m-btn--pill m-btn--air pb-gradient-button" title="Shortcut 'ctrl' + 'p' ">
                        <span class="">
                            <i class="la la-plus"></i>
                            <span v-shortkey="['ctrl', 'p']" @shortkey="newRecord()" class="btn btn-transparent dark btn-outline btn-circle btn-sm btn-index-new-record" @click="newRecord" >
                                Add
                            </span>
                        </span>
                    </a>
                </li>
            </ul>

            <div class="model-editing">
                <slot name="header"></slot>

                <div class="table-scrollable" :class="{busy}">
                    <table class="table table-bordered table-responsive table-hover data" v-if="collection.data">
                        <thead>
                            <tr>
                                <th v-for="column in columns">
                                    {{ column.label }}

                                    <sort-link v-if="column.sort" :property="column.relation ? column.relation.key : column.key" :sort="query" @change="load(lastLoad)" />

                                    <component :is="column.headerComponent" v-if="column.headerComponent" :column="column" @input="Object.assign(query, $event); debounceLoad()"></component>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,ind) in collection.data" :class="{active: item == selectedItem && $route.params.id}" @click="formType ? $router.push({params: {id: item.id}}) : null">
                                <td v-for="column in columns">
                                    <component :is="column.valueComponent" v-if="column.valueComponent" @remove="removeItem(ind)" :value="getValue(item, column.key)" />
                                    <span v-else>
                                        {{ getValue(item, column.key) }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="form-background" ref="overlay" @click="close()" v-show="$route.params.id || visible"></div>
                <transition name="fade">
                    <div class="model-form" :class="{errors: hasErrors, 'full-screen': fullScreen}" v-show="$route.params.id || visible">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <span class="m-portlet__head-icon">
                                        <a href @click.prevent="fullScreen = !fullScreen">
                                            <i class="la" :class="fullScreen ? 'la-compress' : 'la-expand'"></i>
                                        </a>
                                    </span>
                                    <span class="m-portlet__head-icon ">
                                        <i class="la la-gear"></i>
                                    </span>
                                    <h3 class="m-portlet__head-text">
                                        {{ newItem ? "Create" : "Edit" }} {{formType}}
                                    </h3>
                                </div>
                            </div>
                            <div class="m-portlet__head-tools">
                                
                                <ul class="translations-pills nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm" role="tablist" v-if="hasTranslations" style="margin-top: 20px;margin-right: 22px;">
                                    <li v-for="lang in $lang.all" class="nav-item m-tabs__item">
                                        <a @click.prevent="$lang.toggle(lang)" :class="{'active': $lang.isActive(lang)}" class="nav-link m-tabs__link"> {{lang}} </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <form @submit.prevent="$refs.form.save" class="m-form m-form--label-align-right m-form--state">

                            <div class="m-portlet__body">
                                <div class="m-form__section m-form__section--first">
                                    <component :is="formType" :value="selectedItem" @create="create" @update="update" @remove="remove" @error="error" ref="form" />

                                    <div class="m-portlet__foot m-portlet__foot--fit">
                                        <div class="m-form__actions m-form__actions" v-if="$refs.form">
                                            <button class="btn btn-success" @click.prevent="$refs.form.save">
                                                <span v-if="$refs.form.exists" :disabled="$refs.form.form.busy">
                                                    <span v-if="$refs.form.form.busy">
                                                        Updating...
                                                        <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                                                    </span>
                                                    <span v-else>Update</span>
                                                </span>
                                                <span v-else>Create</span>
                                            </button>
                                            <confirm-popover @confirm="$refs.form.remove" v-if="$refs.form.exists">
                                                Remove
                                            </confirm-popover>
                                            <a @click.prevent="close()" v-shortkey="['esc']" @shortkey="close()" class="btn btn-default">Cancel</a>
                                            <span @click.prevent="reloadForm()" class="btn btn-default"><i class="flaticon-refresh"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                    </div>
                </transition>
            </div>
            <div class="text-center">
                <pagination :resource="collection" @load="load"></pagination>
            </div>

        </block>
    </div>

</template>
<style>
.fade-enter-active,
.fade-leave-active {
    transition: transform .5s
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */
{
    transform: translateX(100%);
}

.table-scrollable.busy tbody {
    color: #aaa;
    pointer-events: none;
}

.table-scrollable.busy tbody *:hover {
    background: inherit;
    color: inherit;
}

.model-editing {
    position: relative;
}

.model-form {
    position: fixed;
    overflow: auto;
    width: 820px;
    max-width: 100%;
    top: 50px;
    bottom: 0;
    background: white;
    right: 0;
    padding: 30px 0px !important;
    border: 1px solid #eee;
    z-index: 10;
    box-shadow: -1px 0 7px rgba(0, 0, 0, 0.3);
}
.model-form.full-screen {
    width: 100%;
}

.form-background {
    z-index: 1;
    position: fixed;
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

.metronic-index table tr {
    cursor: pointer;
    border-bottom: 1px solid #F2F2F2;
}

input.index-search {
    display: block;
}

.model-form.errors {
    animation: highlight 300ms ease-in;
}

@keyframes highlight {
    0% {
        background-color: #F26161;
    }
    100% {
        background-color: #fff;
    }
}

.resume-item.successful {
    animation: highlight 300ms ease-in;
}

.portlet.light>.portlet-title>.actions {
    padding: 4px 0 14px;
}

.translations-pills .nav-item a {
    cursor: pointer;
}

.btn.index-new-record {
    padding: .25rem 1rem;
    color: white;
}

.btn-index-new-record {
    font-size: 16px;
    color: white;
}

.index-new-record .la-plus {
    color: white;
    font-weight: bold;
}

.table.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
}

.table.table-responsive thead tr {
    background: #f4f3fb;
}

.table-bordered thead td:not(:last-child),
.table-responsive thead th:not(:last-child) {
    border-right: 1px solid #d4d5d7;
}

.form-tabs {
    position: relative;
    top: 14px;
}

.form-trans {
    position: relative;
    top: 10px;
    right: 30px;
}
</style>

<script>
import axios from 'axios';
import debounce from 'lodash/debounce';
import toastr from 'mini-toastr';
const CancelToken = axios.CancelToken;
export default {
    props: ['api', 'labels', 'formType', 'title', 'id', 'meta'],
    data() {
        return {
            collection: {},
            selectedItem: {},
            newItem: false,
            lastLoad: '',
            busy: false,
            query: {
                by: 'id',
                direction: 'asc'
            },
            visible: false,
            hasErrors: false,
            fullScreen: localStorage.getItem('m-index-fullscreen') === 'true' ? true : false
        };
    },
    methods: {
        newRecord() {
            this.visible = true;
            if (!this.newItem) {
                this.$refs.form.clear();
            }
            this.newItem = true;
        },
        create() {
            toastr.success('Successfully created');
            this.newItem = false;
            this.selectedItem = null;
            this.visible = false;
            this.load(this.lastLoad);
        },
        update(model) {
            const index = this.collection.data.findIndex(x => x.id == model.id);
            toastr.success('Successfully updated');
            if (index !== -1) {
                this.collection.data.splice(index, 1, model);
            }
        },
        error() {
            this.hasErrors = true;
            setTimeout(() => {
                this.hasErrors = false;
            }, 1500);
        },
        showItem(item) {
            this.newItem = false;
            this.selectedItem = item;
            this.$refs.form.load();
            this.$refs.form.confirm = false;
        },
        load(url) {
            url = url || this.api;
            this.lastLoad = url;
            if (this.cancel) {
                this.cancel();
            }
            this.busy = true;
            return axios.get(url, {
                params: this.query,
                cancelToken: new CancelToken((c) => this.cancel = c)
            })
            .then(res => {
                this.collection = res.data;
                // Change resource.path to use the same protocol as the current location
                const currentProtocol = window.location.protocol; // will be 'http:' or 'https:'
                if (this.collection.path && this.collection.path.startsWith('http://') && currentProtocol === 'https:') {
                    this.collection.path = this.collection.path.replace('http://', 'https://');
                } else if (this.collection.path && this.collection.path.startsWith('https://') && currentProtocol === 'http:') {
                    this.collection.path = this.collection.path.replace('https://', 'http://');
                }
                this.busy = false;
            }, () => {
                this.busy = false;
            });
        },


        debounceLoad: debounce(function() {
            this.load();
        }, 200),
        remove() {
            toastr.success('Successfully deleted');
            this.confirm = false;
            this.$refs.form.clear();
            this.load(this.lastLoad);
            this.close();
        },
        removeItem(index) {
            this.collection.data = this.collection.data.filter((x,ind) => ind !== index);
        },
        getValue(item, key, defaultVal = null) {
            // Key can have dot notation to pull nested elements
            let value = item;
            key.split('.').forEach(key => {
                if (!value) {
                    return defaultVal;
                }
                value = value[key];
            });
            return value;
        },
        loadForm(id) {
            const form = this.collection.data && this.collection.data.find(x => x.id == id);
            if (form) {
                this.showItem(form);
                return;
            }
            axios.get(`${this.api}/${id}`).then(res => {
                this.showItem(res.data);
            });
        },
        reloadForm(){
            axios.get(`${this.api}/${this.id}`).then(res => {
                this.showItem(res.data);
            });
        },
        close() {
            this.$router.push({
                params: {
                    id: null
                }
            });
            this.visible = false;
        }
    },
    computed: {
        hasTranslations() {
            return this.meta && this.meta.translations;
        },
        showCreateButton() {
            if(this.meta &&  this.meta.createButton == false){
                return false;
            }
            return true;
        },
        blockTitle() {
            let title = this.title;
            if (this.collection && this.collection.total) {
                title = this.title + ` (${this.collection.total})`;
            }
            return title;
        },
        columns() {
            if (Array.isArray(this.labels)) {
                return this.labels.map(column => {
                    return Object.assign({}, column, {
                        search: column.search === undefined ? true : column.search,
                        sort: column.sort === undefined ? true : column.sort
                    });
                });
            }
            return Object.keys(this.labels).map(key => {
                return {
                    key: key,
                    label: this.labels[key],
                    search: true,
                    sort: true
                };
            });
        }
    },
    watch: {
        id(id) {
            if (id) {
                this.loadForm(id);
            }
        },
        api() {
            this.query = {
                by: 'id',
                direction: 'asc'
            };
            this.selectedItem = {};
            this.load();
        },
        fullScreen(value) {
            localStorage.setItem('m-index-fullscreen', value);
        }
    },
    mounted() {
        document.body.appendChild(this.$refs.overlay);
        this.load();
        if (this.id) {
            this.loadForm(this.id);
        }
    },
    beforeDestroy() {
        this.$refs.overlay.remove();
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/Index.vue